import $i18n from '@/i18n';
import { cloneDeep } from 'lodash';
import { Icon } from '@b-design/fusion';
import Space from '@/components/Space';
import { formatTime } from '@/utils';
import ColorTags from '@/components/ColorTags';
import { getMemberStatus } from '@/utils/status.tsx';
import { HasAigcRole, HasOperatorRole } from '@/utils/config';

export const urlEmun = {
  add: '/rest/intercnn/space/auth/add',
  disable: '/rest/intercnn/space/auth/disable',
  unblock: '/rest/intercnn/space/auth/add',
};

const statusEmun = {
  ACTIVATE: $i18n.get({
    id: 'aopf.pages.getMemberStatus.active',
    dm: '激活',
  }),
  BLOCKED: $i18n.get({
    id: 'aopf.pages.getMemberStatus.disabled',
    dm: '冻结',
  }),
};

const handleFilters = (values) => {
  const filter = [];
  for (const [key, value] of Object?.entries(values)) {
    filter?.push({ label: value, value: key });
  }
  return filter;
};

const roleEmun = {
  ADMIN: $i18n.get({
    id: 'aopf.pages.member.actionSetAsAdmin',
    dm: '管理员',
  }),
  DEVELOPER: $i18n.get({
    id: 'aopf.pages.member.actionSetAsDeveloper',
    dm: '开发者',
  }),
};

if (HasOperatorRole()) {
  Object.assign(roleEmun, {
    OPERATOR: $i18n.get({
      id: 'aopf.component.member.const.OperationsAdministrator',
      dm: '运营管理员',
    })
  });
}

if (HasAigcRole()) {
  Object.assign(roleEmun, { AIGC_DESIGNER: $i18n.get({ id: 'aopf.component.member.const.AigcDesigner', dm: 'AIGC设计者' }), });
}

const roleFilters = handleFilters(roleEmun);

const statusFilters = handleFilters(statusEmun);

const renderName = (_v, _i, record) => {
  return (
    <>
      {record?.userNick}
      <br />
      <span style={{ color: 'rgba(146,152,172,1)' }}>{record?.account}</span>
    </>
  );
};

export const renderActionItem = ({ icon, content, disable = false }) => {
  return (
    <Space
      style={disable ? { color: 'rgba(212,214,225,1)' } : { cursor: 'pointer' }}
      marginRight={4}
    >
      <Icon type={icon} size={'xs'} />
      {content}
    </Space>
  );
};

export const appMemberColumns = [
  {
    title: $i18n.get({ id: 'aopf.pages.member.columnsNames', dm: '名称' }),
    dataIndex: 'userNick',
    // width: 140,
    cell: renderName,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.columnsRole', dm: '角色' }),
    dataIndex: 'roleList',
    cell: (value) => {
      const _value = cloneDeep(value || []);

      if (!_value.length) return '';

      if (_value.length === 1) {
        return roleEmun[_value[0]];
      }

      // 管理员 > AIGC设计者 > 开发者
      if (_value.includes('ADMIN') && _value.includes('DEVELOPER')) {
        const index = _value.indexOf('DEVELOPER');
        _value.splice(index, 1);
      }

      if (_value.includes('ADMIN') && _value.includes('OPERATOR')) {
        const index = _value.indexOf('OPERATOR');
        _value.splice(index, 1);
      }

      const sortValue = _value?.sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase()));
      const _text = sortValue.map((v) => roleEmun[v]);
      return _text.join(' | ');
    },
    filters: roleFilters,
    filterMode: 'single',
    // width: 140,
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.columnsStatus', dm: '状态' }),
    dataIndex: 'status',
    cell: (value) => <ColorTags {...getMemberStatus(value)} />,
    filters: statusFilters,
    filterMode: 'single',
  },
  {
    title: $i18n.get({ id: 'aopf.pages.member.columnsCreatedOn', dm: '创建时间' }),
    dataIndex: 'gmtCreate',
    // width: 140,
    cell: (value) => formatTime(value),
  },
];
